import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import Home from './pages/Home';
import LocationDisclosure from './pages/LocationDisclosure';
import LocationDisclosureV2 from './pages/LocationDisclosure/LocationDisclosureV2';
import SpotLocationDisclosure from './pages/SpotLocationDisclosure';
import LocationDetailRoute from './pages/location/[id]';
import LocationEditRoute from './pages/location/edit/[id]';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/home" element={<Home />} />
          <Route path="/post-location" element={<LocationDisclosureV2 />} />
          <Route path="/post-location-old" element={<LocationDisclosure />} />
          <Route path="/spot-submitted" element={<SpotLocationDisclosure />} />
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/location/:id" element={<LocationDetailRoute />} />
          <Route path="/location/edit/:id" element={<LocationEditRoute />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
